import React, { useState } from "react";
import "../../index.css";

const Registration = () => {
    const [curso, setCurso] = useState(""); // Estado para controlar el valor del select
    return (
        <>
            {/* Registration Start */}
            <div className="container-fluid bg-registration py-5" style={{ margin: "90px 0" }}>
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-7 mb-5 mb-lg-0">
                            <div className="mb-4">
                                <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>Escríbenos para información</h5>
                                <h1 className="text-white">Obten precios promocionales</h1>
                            </div>
                            <p className="text-white">Regístrate e indicanos en qué curso estas interesado y obten tarifas de preventa SIEMPRE</p>
                            <ul className="list-inline text-white m-0">
                                <li className="py-2"><i className="fa fa-check text-primary mr-3"></i>Tarifas promocionales</li>
                                <li className="py-2"><i className="fa fa-check text-primary mr-3"></i>Mantente al tanto de nuestros cursos</li>
                                <li className="py-2"><i className="fa fa-check text-primary mr-3"></i>Información de interés</li>
                            </ul>
                        </div>
                        <div className="col-lg-5">
                            <div className="card border-0">
                                <div className="card-header bg-light text-center p-4">
                                    <h1 className="m-0">¡Registrate ahora!</h1>
                                </div>
                                <div className="card-body rounded-bottom bg-primary p-5">
                                    <form>
                                        <div className="form-group">
                                            <input type="text" className="form-control border-0 p-4" placeholder="Nombre completo" required="required" />
                                        </div>
                                        <div className="form-group">
                                            <input type="email" className="form-control border-0 p-4" placeholder="Email" required="required" />
                                        </div>
                                        <div className="form-group">
                                            <input type="text" className="form-control border-0 p-4" placeholder="Nro de celular con código de área" required="required" />
                                        </div>
                                        <div className="form-group">
                                            <select
                                                className="custom-select border-0 px-4"
                                                style={{ height: "47px" }}
                                                value={curso}
                                                onChange={(e) => setCurso(e.target.value)}
                                            >
                                                <option value="">Selecciona un curso</option>
                                                <option value="programacion">Aprende programación de software en sólo 4 semanas</option>
                                                <option value="web-programadores">Páginas web para programadores</option>
                                                <option value="web-noexpertos">Páginas web para no expertos</option>
                                                <option value="resina">Trabaja con Resina Epóxica</option>
                                                <option value="locucion">Producción y Locución Radial</option>
                                                <option value="liderazgo">Liderazgo y emprendimiento</option>
                                            </select>
                                        </div>
                                        <div>
                                            <button className="btn btn-dark btn-block border-0 py-3" type="submit">Regístrate ahora</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Registration End */}
        </>
    );
};

export default Registration;
